import { flowRight } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { formValues } from 'redux-form';
import { withProps } from 'recompose';
import computeInvestment from 'common/model/simulation/scpi/computeInvestment';
import { formatAmount } from 'common/utils/format';
import { DisabledField } from 'components/form/field';

const InvestmentInner = ({ amount, namePrefix = 'data' }) => (
    <DisabledField
        name={`${namePrefix}.investmentAmount`}
        title="Montant estimé de l'investissement"
        value={formatAmount(amount)}
    />
);

InvestmentInner.propTypes = {
    amount: PropTypes.number.isRequired,
    namePrefix: PropTypes.string.isRequired,
};

const Investment = flowRight([
    formValues(({ namePrefix = 'data' }) => ({
        products: `${namePrefix}.products`,
    })),
    withProps(({ products, namePrefix = 'data' }) => ({
        amount: computeInvestment(products),
        namePrefix,
    })),
])(InvestmentInner);

export default Investment;
